import React, { useEffect, useRef, useState } from "react"
import { Header } from "../UI"
import DataTable from "react-data-table-component"
import { capitalize, lowerCase, upperCase } from "lodash"
import moment from "moment-timezone"
import Loader from "../asserts/Spin.gif"
import { useDispatch, useSelector } from "react-redux"
import {
  deleteBookings,
  getAllBookings,
  getBookingByDates,
  getBookingBySearch,
  updateBookingStatus,
} from "../../axios/api/apiModule"
import { openToastify } from "../store/actions/toastifyAction"
import { REDUX_STORE_DEFAULTS, REDUX_TOASTIFY_DEFAULTS } from "../store/config"
import { bookingAction } from "../store/actions/bookingAction"
import { AppointmentData } from "../config/bookingDataConfig"
import ViewBooking from "../UI/ViewBooking"
import CreateBooking from "../UI/createBooking/CreateBooking"
import { SendMsgEmail } from "../data/modal/SendMsgEmail"
import AssignEmployeeModal from "../modals/AssignEmployeeModal "

const Booking = () => {
  const [bookingData, setBookingData] = useState([])
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 10,
    totalPages: 1,
    total: 0,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [isEditData, setIsEditData] = useState(false)
  const [isForm, setIsForm] = useState(false)
  const [isViewBooking, setIsViewBooking] = useState(false)
  const [isFilterbyDate, setIsFilterbyDate] = useState(false)
  const [isData, setIsData] = useState()
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const dispatch = useDispatch()
  const [bookingDataType, setBookingDataType] = useState("all")
  const [selectedRows, setSelectedRows] = useState([])
  const [isSearch, setIsSearch] = useState()
  let { allBookingData, isBookingUpdated } = useSelector(
    (state) => state.bookingReducer,
  )
  const [assignModal, setAssignModal] = useState(false)
  const [selectedAssignBooking, setSelectedAssignBooking] = useState({
    empAssigned: [],
    shortBookingId: "",
  })
  let { employeeListData } = useSelector((state) => state.employeeReducer)

  const handleGetAllBookingApi = async (
    location = "shop",
    page = 1,
    pageSize = 11,
  ) => {
    try {
      setIsLoading(true)

      const payload = {
        locationType: location,
        page,
        pageSize,
      }

      const response = await getAllBookings(payload)

      if (response.success) {
        const newBookings = response?.data?.bookings || []

        setBookingData((prev) => {
          // ✅ page 1 → replace
          if (page === 1) {
            return newBookings
          }

          // ✅ page > 1 → append without duplicates
          const existingIds = new Set(prev.map((b) => b._id))

          const filtered = newBookings.filter((b) => !existingIds.has(b._id))

          return [...prev, ...filtered]
        })

        setPagination(response?.data?.pagination)
      }

      console.log("getAllBookings", response)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    console.log("allBookingData?.booking", allBookingData)

    if (allBookingData?.bookings) {
      setBookingData(allBookingData?.bookings)
      setPagination(allBookingData?.pagination)
    }
    // handleGetAllBookingApi(bookingDataType, pagination.page + 1, 10)
  }, [allBookingData?.bookings])

  const changeData = (type) => {
    setBookingDataType(type)
    console.log(startDate && endDate)

    if (startDate && endDate) {
      handleGetBookingByDates(type)
    } else {
      handleGetAllBookingApi(type, 1, 11)
    }

    // const bookings = allBookingData?.bookings || []

    // if (!bookings.length) {
    //   setBookingData([])
    //   return
    // }
    // setIsLoading(true)

    // let filteredData = []

    // if (type === "shop") {
    //   setBookingDataType("shop")

    //   filteredData = bookings.filter((item) => item.locationType === "shop")
    // } else if (type === "mobile") {
    //   setBookingDataType("mobile")

    //   filteredData = bookings.filter((item) => item.locationType === "mobile")
    // } else {
    //   setBookingDataType("all")

    //   filteredData = bookings
    // }

    // // sort newest first
    // filteredData = filteredData.sort(
    //   (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    // )

    // setBookingData(filteredData)

    // setIsLoading(false)
  }

  const handlePageChange = (page) => {
    console.log("Current Page:", page)

    // Only fetch if going forward
    if (page > pagination.page && bookingData.length !== pagination?.total) {
      handleGetAllBookingApi(bookingDataType, page, pagination.pageSize)
    }
  }
  const handleRowPerPage = (newPerPage) => {
    console.log("Rows per page:", newPerPage)
    // setBookingData([]) // reset existing data
    // handleGetAllBookingApi(bookingDataType, 1, newPerPage)
  }

  const handleGetBookingByDates = async (locationType = bookingDataType) => {
    if (!startDate || !endDate) {
      dispatch(
        openToastify(
          "Enter Date",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_ERROR(),
        ),
      )
      return
    }

    try {
      setIsLoading(true)
      const payload = {
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
        locationType: locationType,
      }
      const response = await getBookingByDates(payload)
      if (response.success) {
        setBookingData(response?.data?.orders)
        setPagination({
          page: 0,
          pageSize: 10,
          totalPages: 1,
          total: response?.data?.orders?.length,
        })
      }
      console.log(response)
      setIsFilterbyDate(true)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handleDateReset = () => {
    setStartDate("")
    setEndDate("")
    handleGetAllBookingApi(bookingDataType, 1, 11)
    setBookingData([])
    setIsFilterbyDate(false)
  }

  // Search Booking START
  const handleSearchBooking = async (searchQuery) => {
    try {
      const payload = {
        search: searchQuery,
      }
      const response = await getBookingBySearch(payload)
      if (response.success) {
        setBookingData(response.data || [])
      }
      console.log(response)
    } catch (error) {}
  }
  useEffect(() => {
    console.log(isSearch, "isSearch")
    setTimeout(() => {
      if (isSearch) {
        handleSearchBooking(isSearch)
      } else if (isSearch === "") {
        handleGetAllBookingApi(bookingDataType, 1, 11)
      }
    }, 1000)
  }, [isSearch])
  const handleKeyDown = (e) => {
    // Prevent the default behavior for the up and down arrow keys
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault()
    }
  }
  // Search Booking END

  // Change Booking Status (START)
  const BookingStatus = [
    {
      status: "pending",
    },
    {
      status: "confirmed",
    },
    {
      status: "processing",
    },
    {
      status: "cancelled",
    },
    {
      status: "completed",
    },
  ]
  // Hit update booking Status Api
  const hitUpdateBookingStatusApi = async (id, status) => {
    try {
      const payload = {
        id: id,
        status: status,
      }

      const response = await updateBookingStatus(payload)

      if (response.success) {
        const updatedBooking = response?.data?.booking

        // ✅ Update local state
        setBookingData((prev) =>
          prev.map((booking) =>
            booking._id === updatedBooking._id ? updatedBooking : booking,
          ),
        )

        // ✅ Update Redux store booking list
        const updatedReduxBookings = allBookingData?.bookings?.map((booking) =>
          booking._id === updatedBooking._id ? updatedBooking : booking,
        )

        // dispatch(
        //   bookingAction(REDUX_STORE_DEFAULTS.UPDATE_ALL_BOOKING_DATA(), {
        //     bookings: updatedReduxBookings,
        //     pagination: allBookingData?.pagination,
        //   }),
        // )
      }

      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }
  const [isBookingStatus, setIsBookingStatus] = useState({ bookingIds: [] })
  const handlebookingStatus = (event, locationType, id) => {
    console.log(event, locationType, id)
    hitUpdateBookingStatusApi(id, event)
  }
  // Change Booking Status (END)

  const hitDeleteBookingApi = async (id, locationType) => {
    try {
      const params = {
        locationType: locationType,
        bookingIds: id,
      }
      const response = await deleteBookings(params)
      console.log(response)
      if (response.success) {
        dispatch(
          openToastify(
            "Deleted Successfuly",
            REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_SUCCESS(),
          ),
        )
        update()
      }
    } catch (error) {
      console.log(error)
      dispatch(
        openToastify(
          error?.response?.data?.msg,
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_ERROR(),
        ),
      )
    }
  }

  const handleSelectedRowsChange = (state) => {
    const ids = state.selectedRows.map((item) => {
      return item._id
    })
    // console.log("SelectedRows", ids, state)
    // setSelectedRows(ids)
  }

  const edit = (id) => {
    bookingData.map((booking) => {
      if (booking._id === id) {
        setIsData(booking)
      }
    })
    setIsForm(true)
    setIsEditData(true)
  }
  const closeEdit = () => {
    if (isForm) {
      setIsData()
      setIsForm(false)
    }
    setIsEditData(false)
    changeData(bookingDataType)
  }

  const view = (id) => {
    bookingData.map((booking) => {
      if (booking._id === id) {
        setIsData(booking)
      }
    })
    setIsViewBooking(true)
  }

  const closeView = () => {
    if (isViewBooking) {
      setIsViewBooking(false)
      setIsData()
    }
  }

  const remove = (ids, locationType) => {
    console.log(ids, "ids")
    // hitDeleteBookingApi(ids, locationType)
    dispatch(
      openToastify(
        "Delete Booking is Available",
        REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_INFO(),
      ),
    )
  }

  const assignEmployee = (info) => {
    setAssignModal(true)
    setSelectedAssignBooking(info)
  }
  const handleAssignedEmplyee = ({ bookingId, selected }) => {
    // Convert empIds → employee objects
    const assignedEmployees = employeeListData.filter((emp) =>
      selected.includes(emp.empId),
    )

    // Update local state
    setBookingData((prev) =>
      prev.map((booking) =>
        booking.shortBookingId === bookingId
          ? { ...booking, empAssigned: assignedEmployees }
          : booking,
      ),
    )

    // Update redux bookings
    const updatedReduxBookings = (allBookingData?.bookings || []).map(
      (booking) =>
        booking.shortBookingId === bookingId
          ? { ...booking, empAssigned: assignedEmployees }
          : booking,
    )

    dispatch(
      bookingAction(REDUX_STORE_DEFAULTS.UPDATE_ALL_BOOKING_DATA(), {
        bookings: updatedReduxBookings,
        pagination: allBookingData?.pagination,
      }),
    )
  }

  const getStatusColor = (status, location, isAppbooking) => {
    const statusColors = {
      pending: "bg-[#F6BF26]", // banana
      processing: "bg-[#E67C73]", // flamingo
      confirmed:
        location === "shop"
          ? isAppbooking
            ? "bg-[#0B8043]" // basil
            : "bg-[#33B679]" // sage
          : isAppbooking
            ? "bg-[#3F51B5]" // blueberry
            : "bg-[#039BE5]", // peacock
      completed: "bg-[#616161]", // graphite
      cancelled: "bg-[#D50000]", // tomato
    }

    return statusColors[status] || "#7986CB" // default lavender
  }
  //booking table
  const bookingGrid = [
    {
      name: "ID",
      selector: (row) => "#" + row.shortBookingId,
      sortable: true,
      // reorder: true,
    },
    {
      name: "Personal Info",
      // selector: (row) => moment(row.bookingTimeSlot).format("hh:mm A"),
      selector: (row) => (
        <div className="space-y-1 py-1 flex flex-col">
          <span>{row.firstName}</span>
          <a className="text-blue-600" href={`mailto:${row.email}`}>
            {row.email}
          </a>
          <a href={`tel:${row.phoneNumber}`}>{row.phoneNumber}</a>
          <span>{row.location}</span>
        </div>
      ),
      // sortable: true,
      // reorder: true,
    },
    {
      name: "Appointment Time",
      selector: (row) => (
        <div>
          <span>
            {moment
              .tz(
                `${row.bookingDate} ${row.bookingSlot}`,
                "YYYY-MM-DD HH:mm",
                "America/Vancouver",
              )
              .format("YYYY-MM-DD")}
          </span>
          <br />
          <span>
            {moment
              .tz(
                `${row.bookingDate} ${row.bookingSlot}`,
                "YYYY-MM-DD HH:mm",
                "America/Vancouver",
              )
              .format("hh:mm A")}
          </span>
        </div>
      ),
      sortable: true,
      // reorder: true,
    },
    {
      name: "Booking Type",
      selector: (row) => capitalize(row.locationType),
      // sortable: true,
      // reorder: true,
    },
    {
      name: "Amount",
      selector: (row) => "$" + row.totalAmount.toFixed(2),
      sortable: true,
      reorder: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="">
          <select
            name="bookingStatus"
            id="bookingStatus"
            className={` h-9 rounded-md px-2 text-white border border-black ${getStatusColor(row.bookingStatus, row.locationType, row.isAppbooking)} `}
            value={
              row._id === isBookingStatus?.bookingIds[0]
                ? isBookingStatus.updatedStatus
                : row.bookingStatus
            }
            onChange={(e) =>
              handlebookingStatus(e.target.value, row.locationType, row._id)
            }
            required
          >
            {BookingStatus.map((item) => (
              <option
                className="bg-white text-black"
                key={item.status}
                value={item.status}
              >
                {capitalize(item.status)}
              </option>
            ))}
          </select>
          {/* {row.bookingStatus === "processing" && (
            <span className="px-3 rounded-full bg-yellow-medium_dark">
              {capitalize(row.bookingStatus)}
            </span>
          )}
          {row.bookingStatus === "cancelled" && (
            <span className="px-3 rounded-full bg-red-600">
              {capitalize(row.bookingStatus)}
            </span>
          )}
          {row.bookingStatus === "confirmed" && (
            <span className="px-3 rounded-full bg-orange-600">
              {capitalize(row.bookingStatus)}
            </span>
          )}
          {row.bookingStatus === "completed" && (
            <span className="px-3 rounded-full bg-green-600">
              {capitalize(row.bookingStatus)}
            </span>
          )} */}
        </div>
      ),
      sortable: true,
      reorder: true,
    },
    {
      name: "Booked Time",
      selector: (row) => moment(row.createdAt).format("YYYY-MM-DD hh:mm A"),
      sortable: true,
      // reorder: true,
    },
    {
      name: "Notifications",
      selector: (row) => (
        <div className="flex flex-col space-y-1 text-center text-white">
          <span
            className={` px-3 rounded-full ${
              row.bookingCnfMsg?.emailSend ? "bg-green-600" : "bg-red-600"
            } `}
          >
            Email
          </span>
          <span
            className={` px-3 rounded-full ${
              row.bookingCnfMsg?.msgSend ? "bg-green-600" : "bg-red-600"
            } `}
          >
            SMS
          </span>
          {/* <span
            className={` px-3 rounded-full ${
              row.bookingCnfMsg?.eventAdded ? "bg-green-600" : "bg-red-600"
            } `}
          >
            G Event
          </span> */}
        </div>
      ),
      // sortable: true,
      // reorder: true,
    },
    {
      name: "Action",
      // selector: (row) => row.paid,
      cell: (row) => (
        <div className="flex bg-white space-x-3 border-2 shadow-sm shadow-gray-700 rounded-lg p-2">
          <svg
            onClick={() => view(row._id)}
            className="size-5 cursor-pointer text-green-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>

          <svg
            onClick={() => edit(row._id)}
            className="size-5 cursor-pointer text-yellow-light_medium"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
            />
          </svg>

          <div className="relative">
            <svg
              onClick={() => assignEmployee(row)}
              className="size-5 cursor-pointer text-blue-600 hover:scale-110 transition"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 20h5v-1a4 4 0 0 0-3-3.87M17 20H7m10 0v-1c0-.656-.126-1.283-.356-1.856M7 20H2v-1a4 4 0 0 1 3-3.87M7 20v-1c0-.656.126-1.283.356-1.856m0 0a5.002 5.002 0 0 1 9.288 0M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM7 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
              />
            </svg>

            {row?.empAssigned?.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 min-w-[16px] h-[16px] flex items-center justify-center shadow">
                {row.empAssigned.length}
              </span>
            )}
          </div>

          <svg
            className="size-5 cursor-pointer text-red-500"
            onClick={() => remove([row._id], row.locationType)}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
        </div>
      ),
      // sortable: true,
      // reorder: true,
    },
  ]

  const formatDate = (date) => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = `0${d.getMonth() + 1}`.slice(-2) // Adding 1 because months are zero indexed
    const day = `0${d.getDate()}`.slice(-2)
    return `${year}-${month}-${day}`
  }

  useEffect(() => {
    if (!isForm) {
      setIsData({})
    }
  }, [isForm])

  const update = () => {
    dispatch(
      bookingAction(
        REDUX_STORE_DEFAULTS.UPDATE_BOOKING_DATA(),
        !isBookingUpdated,
      ),
    )
  }

  return (
    <div className="m-2 md:m- 10 mt- 16 p-2 md:p-10 bg-white rounded-3xl">
      <div className="flex justify-between items-end">
        <Header title="Bookings" />
        {/* <button
          className="bg-yellow-light text-white h-8 px-3 font-medium rounded-lg hover:shadow-md"
          onClick={() => {
            setIsForm(true)
          }}
        >
          Create Booking
        </button> */}
      </div>

      {/* Filteration */}
      <div className="flex md:items-center text-xs space-x-2 justify-between md:flex-row flex-col">
        <div className="text-white space-x-2 flex items-center">
          <button
            className={` ${
              bookingDataType === "shop"
                ? "bg-yellow-light_medium"
                : "text-black border border-black"
            } h-8 px-5 rounded-lg `}
            onClick={() => {
              changeData("shop")
            }}
          >
            Shop
          </button>
          <button
            className={` ${
              bookingDataType === "mobile"
                ? "bg-yellow-light_medium"
                : "text-black border border-black"
            } h-8 px-5 rounded-lg `}
            onClick={() => {
              changeData("mobile")
            }}
          >
            Mobile
          </button>
          <button
            className={` ${
              bookingDataType === "all"
                ? "bg-yellow-light_medium"
                : "text-black border border-black"
            } h-8 px-5 rounded-lg `}
            onClick={() => {
              changeData("all")
            }}
          >
            All Bookings
          </button>

          {selectedRows.length && bookingDataType !== "all" ? (
            <>
              <button
                title="Delete Bookings"
                onClick={() => remove(selectedRows, bookingDataType)}
              >
                <svg
                  className="size-6 cursor-pointer text-red-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                  />
                </svg>
              </button>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="flex space-x-4 items-end text-xs md:flex-row flex- col mt-5 md:mt-0">
          <div className="flex space-x-4">
            <div className="flex flex-col space-y-1">
              <span>Booking Start Date:</span>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="border p-1 rounded"
              />
            </div>
            <div className="flex flex-col space-y-1">
              <span>Booking End Date:</span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="border p-1 rounded"
              />
            </div>
          </div>
          <div className="flex mt-5 md:mt-0 space-x-4">
            {isFilterbyDate && (
              <button
                onClick={handleDateReset}
                className="bg-slate-400 text-white h-8 px-5 text-base rounded-lg"
              >
                Clear
              </button>
            )}
            <button
              onClick={() => handleGetBookingByDates()}
              className="bg-yellow-light_medium text-white h-8 px-5 text-base rounded-lg"
            >
              Filter
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-1 my-3 space-x-3">
        <input
          type="text"
          className="bg-slate-100 h-8 rounded-lg py-1 px-2 lg:w-[20%] w-full placeholder:text-sm border"
          placeholder="Seach by id, ph, email..."
          minLength={3}
          onKeyDown={handleKeyDown}
          value={isSearch}
          onChange={(e) => {
            setIsSearch(e.target.value)
          }}
        />
        <div className="w-20">
          {isSearch && (
            <button
              onClick={(e) => {
                setIsSearch("")
              }}
              className="bg-slate-400 text-white h-8 px-5 text-base rounded-lg"
            >
              Clear
            </button>
          )}
        </div>
        <button
          className="bg-yellow-light_medium text-white h-8 w-32 px-3 font-medium rounded-lg hover:shadow-md"
          onClick={() => {
            setIsForm(true)
          }}
        >
          Create
        </button>
      </div>

      <DataTable
        // title="Coupons List"
        columns={bookingGrid}
        data={bookingData ?? []}
        pagination
        fixedHeader
        selectableRows={bookingDataType !== "all"}
        fixedHeaderScrollHeight="480px"
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowPerPage}
        // paginationDefaultPage={pagination?.page}
        paginationTotalRows={pagination?.total || 0}
        onSelectedRowsChange={handleSelectedRowsChange}
      />
      {assignModal && (
        <AssignEmployeeModal
          bookingId={selectedAssignBooking?.shortBookingId}
          employees={employeeListData?.filter((emp) => emp.role === "employee")}
          selectedEmployees={selectedAssignBooking?.empAssigned || []}
          onClose={() => setAssignModal(false)}
          onAssign={(info) => handleAssignedEmplyee(info)}
        />
      )}

      {isLoading ? (
        <div className=" absolute inset-0 z-50 flex justify-center items-center backdrop-blur-sm">
          <img src={Loader} alt="" className="size-12" />
        </div>
      ) : (
        <></>
      )}

      {/* booking form */}
      {isForm ? (
        <>
          <CreateBooking
            data={isData}
            onClick={closeEdit}
            isEdit={isEditData}
          />
        </>
      ) : (
        <></>
      )}

      {/* View form */}

      {isViewBooking ? (
        <>
          <ViewBooking data={isData} onClick={closeView} />
        </>
      ) : (
        <></>
      )}
    </div>
  )
}
export default Booking
